module.exports = __webpack_public_path__ + "img/hy03.40a82114.jpg";